export default () => {
  const $banner = $('.c-promoBanner')

  if (!$banner.length) {
    return
  }

  const updateVisibility = () => {
    $banner.toggleClass('is-hidden', window.scrollY > 0)
  }

  updateVisibility()
  $(window).on('scroll', updateVisibility)
}
